export enum ChannelTypeEnum {
  STYLE = 1,
  LINE_ITEM = 2,
}
